import { useRutaCliente } from "@/hooks/useRutaCliente";
import { AGENCIA } from "@/utils/agencia";
import { StatePage } from "./StatePage";

type PermissionStateProps =
  | { variante: "tienda" }
  | { variante: "agencia"; cliente: string };

/**
 * Sin permiso (interaction.md §3): ocupa el área de contenido y esa sección no sale en la navegación.
 * Lo decide el rol de `/auth/me`, no el código HTTP (el servidor responde 404 a la tienda en rutas de agencia).
 */
export function PermissionState(props: PermissionStateProps) {
  const ruta = useRutaCliente();
  if (props.variante === "tienda") {
    return <StatePage title={`Esta sección la lleva ${AGENCIA}.`} action={{ to: ruta("inicio"), label: "Ir a Inicio" }} />;
  }
  return (
    <StatePage
      title={`No tienes acceso a ${props.cliente}.`}
      body="Pídeselo a quien administra la agencia."
      action={{ to: "/clientes", label: "Ver mis clientes" }}
    />
  );
}
